var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottomcolor"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"rule",domProps:{"innerHTML":_vm._s(_vm.obj)}})])}
var staticRenderFns = []

export { render, staticRenderFns }